/* pro3 "bought together" recommendation beacons (docs/recs.md in signwarehouse-app).
 *
 * snippets/sw-recs-config.liquid assigns the arm and swaps pro3's picks in; this file only reports what happened:
 *   impression  a recommendation slot rendered (arm, placement, the product ids shown, possibly none)
 *   click       a card link in a slot
 *   cart        quick add from a card, "Add all to cart", or an add on a product page reached from a card (30 min)
 * Beacons go to pro3 through the app proxy (/apps/pro/recs/events). The cart is stamped once with the session id
 * (cart attribute _sw_sid, shared with search) so pro3 can attribute the order from Shopify's webhook; the browser
 * never names a customer or an order. Automated browsers (navigator.webdriver) send nothing.
 */
(function () {
  var R = window.swRecs;
  if (!R) return;
  var queue = R.q;
  var timer = null;

  function automated() { try { return navigator.webdriver === true; } catch (e) { return false; } }

  function flush() {
    clearTimeout(timer); timer = null;
    if (!queue.length) return;
    if (automated()) { queue.length = 0; return; }
    var batch = queue.splice(0, 25);
    var body = JSON.stringify({ sid: R.sid(), events: batch });
    var url = R.eventsPath + '/events';
    var sent = false;
    if (navigator.sendBeacon) { try { sent = navigator.sendBeacon(url, new Blob([body], { type: 'text/plain' })); } catch (e) { sent = false; } }
    if (!sent) fetch(url, { method: 'POST', keepalive: true, credentials: 'same-origin', headers: { 'Content-Type': 'text/plain' }, body: body }).catch(function () { /* best effort */ });
    if (queue.length) timer = setTimeout(flush, 500);
    stampCart();
  }
  function later() { if (!timer) timer = setTimeout(flush, 2000); }
  R.flush = later;

  var stamped = false;
  function stampCart() {
    if (stamped || automated()) return;
    stamped = true;
    try { if (sessionStorage.getItem('sw_cart_stamped') === R.sid()) return; } catch (e) { /* ignore */ }
    var attrs = {}; attrs[R.cartAttribute] = R.sid();
    fetch(R.cartUpdate || '/cart/update.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ attributes: attrs }) })
      .then(function () { try { sessionStorage.setItem('sw_cart_stamped', R.sid()); } catch (e) { /* ignore */ } })
      .catch(function () { stamped = false; });
  }

  function slotOf(node) {
    var el = node && node.closest ? node.closest('product-recommendations[data-sw-arm]') : null;
    return el && el.dataset.swPlacement ? el : null;
  }
  function base(slot, type) {
    return { type: type, placement: slot.dataset.swPlacement, arm: slot.dataset.swArm, exp: R.cfg.active ? R.cfg.id : null, anchor: slot.dataset.swAnchor };
  }

  document.addEventListener('click', function (evt) {
    var t = evt.target;
    var slot = slotOf(t);
    if (!slot) return;
    if (t.closest('.add_all_to_cart')) {
      Array.prototype.forEach.call(slot.querySelectorAll('[data-sw-rec]'), function (li) {
        var e = base(slot, 'cart'); e.product_id = li.getAttribute('data-sw-rec'); queue.push(e);
      });
      flush();
      return;
    }
    var card = t.closest('[data-sw-rec]');
    if (!card || !t.closest('a[href]')) return;
    var e = base(slot, 'click');
    e.product_id = card.getAttribute('data-sw-rec');
    e.position = Number(card.getAttribute('data-sw-pos')) || null;
    queue.push(e);
    try { sessionStorage.setItem('sw_rec_last', JSON.stringify({ e: e, t: Date.now() })); } catch (err) { /* ignore */ }
    flush();
  }, true);

  document.addEventListener('on:cart:add', function (evt) {
    var slot = slotOf(evt.target);
    if (slot) {
      var card = evt.target.closest('[data-sw-rec]');
      if (!card) return;
      var e = base(slot, 'cart'); e.product_id = card.getAttribute('data-sw-rec'); queue.push(e); flush();
      return;
    }
    // added on a product page opened from a recommendation card
    try {
      var last = JSON.parse(sessionStorage.getItem('sw_rec_last') || 'null');
      var meta = window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product;
      if (!last || last.t < Date.now() - 30 * 60e3 || !meta || String(meta.id) !== String(last.e.product_id)) return;
      var c = {}; for (var k in last.e) c[k] = last.e[k];
      c.type = 'cart'; delete c.position;
      queue.push(c);
      sessionStorage.removeItem('sw_rec_last');
      flush();
    } catch (err) { /* ignore */ }
  });

  window.addEventListener('pagehide', flush);
  document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'hidden') flush(); });
  if (queue.length) later();
})();
